import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";
import {questionnaireActions, tutorAuthActions} from "_actions";
import {Button, Slider, Row, Col} from 'antd';
import { history } from '_helpers/history'
import { Table, Tag, Space } from 'antd';
import "./index.scss";
import { useParams } from "react-router-dom";

function AssessmentPage(props) {
    const { id } = useParams();

    const dispatch = useDispatch();
    const [index, setIndex] = useState(0)
    const [value, setValue] = useState(0)
    const [assessment, setAssessment] = useState(null)
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    var assestmentsData = useSelector((state) => state.questionnaireReducer.assestmentsData);
    var assestmentsDataError = useSelector((state) => state.questionnaireReducer.assestmentsDataError);



    useEffect(() => {
        dispatch(questionnaireActions.getAssessments(id))
    }, []);
    useEffect(() => {
        if (assestmentsData){
            setAssessment(assestmentsData[0]);
        }
    }, [assestmentsData]);

    const nextAssessment = () => {
        let mIndex = index;
        mIndex ++ ;

        setAssessment(assestmentsData[mIndex]);
        setValue(0);
        setIndex(mIndex);
    }

    const prevAssessment = () => {
        let mIndex = index;
        mIndex -- ;
        setAssessment(assestmentsData[mIndex]);
        setValue(0);
        setIndex(mIndex);
    }

    const marks = {
        0: '0',
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7',
        8: '8',
        9: '9',
        10: '10',


    };
    function onChange(value) {
       setValue(value)
    }
    return (
        <div>



            <div>AssessmentPage {id}</div>

            {assessment &&
                <div style={{margin: "auto"}}>
                    <div className={"assessmentContainer"}>
                        <div className={"assessmentQuestion"}>{assessment.question}</div>
                        <div className={"assessmentDesc"}>{t("assessment.responde")}</div>
                        {assessment.questionType === "RATING" &&
                            <Slider marks={marks} value={value} onChange={onChange} max={10} />

                        }
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                {index > 0 &&
                                    <Button
                                        onClick={() => prevAssessment()}
                                        style={{ zIndex: 100000 }}
                                        type={"primary"}
                                        className="buttonSizeXM btnBorder"
                                    >
                                        {"< " + t("assessment.prev")}
                                    </Button>
                                }
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                {index < assestmentsData.length-1 &&
                                    <Button
                                        onClick={() => nextAssessment()}
                                        type={"primary"}
                                        style={{zIndex: 100000}}
                                        className="btnPrincipal buttonSizeXM btnBorder moveRight"
                                    >
                                        {t("assessment.next") + " >"}
                                    </Button>
                                }
                            </Col>
                        </Row>
                    </div>
                </div>



            }




        </div>
    )
}
export default withTranslation()(AssessmentPage);
